import React, { useState, useEffect } from 'react';
import { Document, Packer, Header, Paragraph, TextRun, HeightRule, convertInchesToTwip, PageNumber,SimpleField,NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import './Operational.css';
import { API_URL } from "./API";



function OperationalChecksForm({ savedGeneralData, project, goBack, contactTestData, reportToUpdate, isUpdateMode }) {
  const [formData, setFormData] = useState({
    mechanical: {
      close: '',
      open: ''
    },
    local: {
      closeTest: '',
      openTest: ''
    },
    remote: {
      closeService: '',
      closeTestService: '',
      tripping: ''
    },
    indication: {
      cbOn: '',
      cbOff: '',
      cbTrip: '',
      breakerTest: '',
      breakerService: '',
      springCharged: '',
      tripCkt1: '',
      tripCkt2: ''
    }
  });
 
  const [circuitBreakerData, setCircuitBreakerData] = useState({});
  const [testData, setTestData] = useState({});
  const [contactData, setContactData] = useState({}); 
  const [operationalChecksData, setOperationalChecksData] = useState({}); 
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(''); 
  const [projectDetails, setProjectDetails] = useState({
    subProjectName: '',
    categoryName: '',
    subcategoryName: '',
    equipmentName: '',
    projectId: '',
    location: ''
  });

  const [reportsList, setReportsList] = useState([]);
  const [selectedReportId, setSelectedReportId] = useState('');
  const [showReportsList, setShowReportsList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateReportId, setUpdateReportId] = useState(null);
 
  


useEffect(() => {
  console.log("=== OperationalUpdate useEffect - Starting data load ===");
  console.log("isUpdateMode:", isUpdateMode);
  console.log("reportToUpdate:", reportToUpdate);
  

  const defaultFormData = {
    mechanical: { close: '', open: '' },
    local: { closeTest: '', openTest: '' },
    remote: { closeService: '', closeTestService: '', tripping: '' },
    indication: {
      cbOn: '', cbOff: '', cbTrip: '', breakerTest: '',
      breakerService: '', springCharged: '', tripCkt1: '', tripCkt2: ''
    }
  };
  
 
  const existingOpData = localStorage.getItem('updateOperationalChecksData');
  console.log("localStorage updateOperationalChecksData:", existingOpData);
  
  if (existingOpData && existingOpData !== '{}' && existingOpData !== 'null') {
    try {
      const parsed = JSON.parse(existingOpData);
      console.log("Parsed operational data from localStorage:", parsed);
      
      if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
       
        const hasValidData = Object.values(parsed).some(section => {
          if (section && typeof section === 'object') {
            return Object.values(section).some(value => value !== '' && value !== null && value !== undefined);
          }
          return false;
        });
        
        if (hasValidData) {
          
          const mergedData = {
            mechanical: { ...defaultFormData.mechanical, ...(parsed.mechanical || {}) },
            local: { ...defaultFormData.local, ...(parsed.local || {}) },
            remote: { ...defaultFormData.remote, ...(parsed.remote || {}) },
            indication: { ...defaultFormData.indication, ...(parsed.indication || {}) }
          };
          
          console.log('✓ Setting formData from localStorage:', mergedData);
          setFormData(mergedData);
          return;
        }
      }
    } catch (e) {
      console.error('Error parsing operational data from localStorage:', e);
    }
  }
  
  
  if (isUpdateMode && reportToUpdate?.test_data?.operationalChecksData) {
    console.log("Loading from reportToUpdate.test_data.operationalChecksData");
    const opData = reportToUpdate.test_data.operationalChecksData;
    console.log("Raw operationalChecksData:", opData);
    
   
    const extractValue = (data, defaultValue = '') => {
      if (!data) return defaultValue;
      
     
      if (typeof data === 'string' || typeof data === 'number') {
        return String(data);
      }
      
      
      if (typeof data === 'object') {
        
        if (data.reading_1 !== undefined && data.reading_1 !== null && data.reading_1 !== '') {
          return String(data.reading_1);
        }
        
       
        const readingKeys = Object.keys(data).filter(k => k.startsWith('reading_')).sort();
        if (readingKeys.length > 0) {
          const firstReading = data[readingKeys[0]];
          if (firstReading !== undefined && firstReading !== null && firstReading !== '') {
            return String(firstReading);
          }
        }
        
       
        if (data.value !== undefined && data.value !== null && data.value !== '') {
          return String(data.value);
        }
      }
      
      return defaultValue;
    };
    
    const loadedFormData = {
      mechanical: {
        close: extractValue(opData.mechanical?.close),
        open: extractValue(opData.mechanical?.open)
      },
      local: {
        closeTest: extractValue(opData.local?.closeTest),
        openTest: extractValue(opData.local?.openTest)
      },
      remote: {
        closeService: extractValue(opData.remote?.closeService),
        closeTestService: extractValue(opData.remote?.closeTestService),
        tripping: extractValue(opData.remote?.tripping)
      },
      indication: {
        cbOn: extractValue(opData.indication?.cbOn),
        cbOff: extractValue(opData.indication?.cbOff),
        cbTrip: extractValue(opData.indication?.cbTrip),
        breakerTest: extractValue(opData.indication?.breakerTest),
        breakerService: extractValue(opData.indication?.breakerService),
        springCharged: extractValue(opData.indication?.springCharged),
        tripCkt1: extractValue(opData.indication?.tripCkt1),
        tripCkt2: extractValue(opData.indication?.tripCkt2)
      }
    };
    
    console.log('✓ Loaded operational data from reportToUpdate:', loadedFormData);
    console.log('  - mechanical.close:', loadedFormData.mechanical.close);
    console.log('  - indication.cbOn:', loadedFormData.indication.cbOn);
    
    setFormData(loadedFormData);
    localStorage.setItem('updateOperationalChecksData', JSON.stringify(loadedFormData));
  } else {
    
    console.log('Setting default empty formData structure');
    setFormData(defaultFormData);
  }
  
 
  if (isUpdateMode && reportToUpdate?.test_data) {
    const testData = reportToUpdate.test_data;
    
    if (testData.circuitBreakerData) {
      const existingCBData = localStorage.getItem('updatecircuitBreakerFormData');
      if (!existingCBData || existingCBData === '{}') {
        setCircuitBreakerData(testData.circuitBreakerData);
        localStorage.setItem('updatecircuitBreakerFormData', JSON.stringify(testData.circuitBreakerData));
      } else {
        setCircuitBreakerData(JSON.parse(existingCBData));
      }
    }
    
    if (testData.testData) {
      const existingTestData = localStorage.getItem('updateTestFormData');
      if (!existingTestData || existingTestData === '{}') {
        setTestData(testData.testData);
        localStorage.setItem('updateTestFormData', JSON.stringify(testData.testData));
      } else {
        setTestData(JSON.parse(existingTestData));
      }
    }
    
    if (testData.contactData) {
      const existingContactData = localStorage.getItem('updateTimeIntervalData');
      if (!existingContactData || existingContactData === '{}') {
        setContactData(testData.contactData);
        localStorage.setItem('updateTimeIntervalData', JSON.stringify(testData.contactData));
      } else {
        setContactData(JSON.parse(existingContactData));
      }
    }
  }
  
  
  try {
    const localProjectData = localStorage.getItem('createReportData');
    
    if (localProjectData) {
      const parsedProjectData = JSON.parse(localProjectData);
      setProjectDetails({
        subProjectName: parsedProjectData.sub_project_name || "",
        categoryName: parsedProjectData.category_name || "",
        subcategoryName: parsedProjectData.subcategory_name || "",
        equipmentName: parsedProjectData.equipment_name || "",
        projectId: parsedProjectData.project_id || "",
        location: parsedProjectData.location || ""
      });
    }
  } catch (error) {
    console.error("Error loading project details:", error);
  }
}, [isUpdateMode, reportToUpdate]);


useEffect(() => {
  if (formData && Object.keys(formData).length > 0) {
    const hasValidData = formData.mechanical || formData.local || formData.remote || formData.indication;
    if (hasValidData) {
      const dataToSave = JSON.stringify(formData);
      localStorage.setItem('updateOperationalChecksData', dataToSave);
      console.log('✓ Saved to localStorage:', dataToSave);
    }
  }
}, [formData]);


const handleChange = (section, field, value) => {
  console.log(`✓ handleChange: section=${section}, field=${field}, value=${value}`);
  
  setFormData(prevData => {
    const updatedData = {
      ...prevData,
      [section]: {
        ...prevData[section],
        [field]: value
      }
    };
    
    console.log('New formData:', updatedData);
    
   
    localStorage.setItem('updateOperationalChecksData', JSON.stringify(updatedData));
    
    return updatedData;
  });
};


useEffect(() => {
 
  if (formData && Object.keys(formData).length > 0) {
    
    const hasValidData = formData.mechanical || formData.local || formData.remote || formData.indication;
    if (hasValidData) {
      localStorage.setItem('updateOperationalChecksData', JSON.stringify(formData));
      console.log('✓ OperationalUpdate useEffect: Saved to localStorage:', formData);
    }
  }
}, [formData]);

  const handleGetReports = async () => {
    try {
      setIsLoading(true);
      setErrorMessage("");
      
      console.log("Fetching test reports...");
      
      const response = await fetch(`${API_URL}/test_report/get_test_reports`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'same-origin',
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
      }
      
      const result = await response.json();
      console.log('GET API Response:', result);
      
      const reports = Array.isArray(result) ? result : (result.reports || result.data || []);
      setReportsList(reports);
      setShowReportsList(true);
      
      alert(`Successfully fetched ${reports.length} test reports!`);
      
    } catch (error) {
      console.error("Error fetching reports:", error);
      
      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running.");
        alert("Cannot connect to server. Please check if the backend is running.");
      } else {
        setErrorMessage(`Error fetching reports: ${error.message}`);
        alert(`Error fetching reports: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const loadAllFormDataFromStorage = () => {
    try {
      const savedCBData = JSON.parse(localStorage.getItem('updatecircuitBreakerFormData') || '{}');
      const savedTestData = JSON.parse(localStorage.getItem('updateTestFormData') || '{}');
      const savedContactData = JSON.parse(localStorage.getItem('updateTimeIntervalData') || '{}');
      const savedOpChecksData = JSON.parse(localStorage.getItem('updateOperationalChecksData') || '{}');
      const savedProjectData = JSON.parse(localStorage.getItem('createReportData') || '{}');
      const savedNavbarData = JSON.parse(localStorage.getItem('navbarData') || '{}');
      
      return {
        circuitBreakerData: { ...circuitBreakerData, ...savedCBData },
        testData: { ...testData, ...savedTestData },
        contactData: { ...contactData, ...savedContactData },
        operationalChecksData: { ...formData, ...savedOpChecksData },
        projectDetails: {
          subProjectName: savedProjectData.sub_project_name || projectDetails.subProjectName || "",
          categoryName: savedProjectData.category_name || projectDetails.categoryName || "",
          subcategoryName: savedProjectData.subcategory_name || projectDetails.subcategoryName || "",
          equipmentName: savedProjectData.equipment_name || projectDetails.equipmentName || "",
          projectId: savedProjectData.project_id || projectDetails.projectId || "",
          location: savedProjectData.location || savedNavbarData.location || projectDetails.location || ""
        }
      };
    } catch (error) {
      console.error("Error loading form data from storage:", error);
      return {
        circuitBreakerData,
        testData,
        contactData,
        operationalChecksData: formData,
        projectDetails
      };
    }
  };

  const clearAllStorageData = () => {
    try {
      localStorage.removeItem('updatecircuitBreakerFormData');
      localStorage.removeItem('updateTestFormData');
      localStorage.removeItem('updateTimeIntervalData');
      localStorage.removeItem('updateOperationalChecksData');
      localStorage.removeItem('updateOperationalInspection');
      localStorage.removeItem('circuitBreakerInspectionPDF');
      localStorage.removeItem('createReportData');
      console.log("All storage data cleared successfully");
    } catch (error) {
      console.error("Error clearing storage data:", error);
    }
  };

  const resetAllFormStates = () => {
    try {
      setFormData({
        mechanical: {
          close: '',
          open: ''
        },
        local: {
          closeTest: '',
          openTest: ''
        },
        remote: {
          closeService: '',
          closeTestService: '',
          tripping: ''
        },
        indication: {
          cbOn: '',
          cbOff: '',
          cbTrip: '',
          breakerTest: '',
          breakerService: '',
          springCharged: '',
          tripCkt1: '',
          tripCkt2: ''
        }
      });

      setCircuitBreakerData({});
      setTestData({});
      setContactData({});
      setOperationalChecksData({});
      
      setProjectDetails({
        subProjectName: '',
        categoryName: '',
        subcategoryName: '',
        equipmentName: '',
        projectId: '',
        location: ''
      });

      setFormSubmitted(false);
      setErrorMessage('');
      setIsUpdating(false);
      setUpdateReportId(null);
      setShowReportsList(false);
      setSelectedReportId('');
      
      console.log("All form states reset successfully");
    } catch (error) {
      console.error("Error resetting form states:", error);
    }
  };



const generateWordBlob = () => {
  return new Promise((resolve, reject) => {
    try {
     
        const storedFormData = JSON.parse(localStorage.getItem('updatecircuitBreakerFormData') || '{}');
        const testFormData = JSON.parse(localStorage.getItem('updateTestFormData') || '{}');
        const coilIntervalData = JSON.parse(localStorage.getItem('updateTimeIntervalData') || '{}');

     
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };

     
      function findValue(data, searchTerms, defaultValue = "N/A") {
        if (!data || typeof data !== 'object') return defaultValue;
        
        const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];
        
        for (let term of terms) {
          if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
            return data[term];
          }
        }
        
        const dataKeys = Object.keys(data);
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        return defaultValue;
      }

      function safeToString(value) {
        if (value === null || value === undefined || value === '' || value === 'N/A') {
          return "";
        }
        return value.toString();
      }

     
      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
              console.warn("Could not convert image to base64:", error);
              resolve(null);
            }
          };
          img.onerror = function() {
            console.warn("Could not load image from URL:", url);
            resolve(null);
          };
          img.src = url;
        });
      };
      
     
     
      const createLightWatermark = (base64Data) => {
        return new Promise((resolve) => {
          if (!base64Data) {
            resolve(null);
            return;
          }
          
          try {
            const img = new Image();
            img.onload = function() {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              
              
              ctx.globalAlpha = 0.15; 
              ctx.drawImage(img, 0, 0);
              
              const lightDataURL = canvas.toDataURL('image/png');
              const lightBase64 = lightDataURL.split(',')[1];
              resolve(lightBase64);
            };
            img.onerror = function() {
              resolve(null);
            };
            img.src = 'data:image/png;base64,' + base64Data;
          } catch (error) {
            console.warn("Could not create light watermark:", error);
            resolve(null);
          }
        });
      };

      
      const documentSections = [];

      
const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
     
   const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg"; 
      
      Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]).then(([logoBase64, watermarkBase64]) => {
        
       
        createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {
       
        const headerElements = [];

        if (logoBase64) {
          headerElements.push(
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoBase64,
                              transformation: {
                                width: 80,
                                height: 80
                              }
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                        })
                      ],
                      verticalAlign: VerticalAlign.CENTER,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 20, type: WidthType.PERCENTAGE },
                      margins: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "PIE POWER PRIVATE LIMITED",
                             font: "Times New Roman",
                              color:"#1e402c",
                              bold: true,
                              size: 36
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 80, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ]
            })
          );
        } else {
        
          headerElements.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "PIE POWER PRIVATE LIMITED",
                  font: "Times New Roman",
                  color:"#1e402c",
                  bold: true,
                  size: 36
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                  font: "Courier New",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                  font: "Courier New",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            })
          );
        }

        headerElements.push(new Paragraph({ text: "" })); 
        documentSections.push(...headerElements);

        
      

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Description", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "CIRCUIT BREAKER INSPECTION/ TEST REPORT", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Date", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.date), font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Project", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.project), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Report No", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.reportNo), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Customer", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.customer), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " "  , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  
                ]
              }),
              new TableRow({
                children: [
                  
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   "Client", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   (storedFormData?.client), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " " , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text: " "  , font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                   
                  
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 



              
        
             documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "LOCATION:",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      }),
                      new TextRun({
                        text: storedFormData.location || '',
                        font: "Courier New",
                        size: 24
                      })
                    ]
                  })
                );
              
                documentSections.push(new Paragraph({ text: "" }));
              

        
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "NAME PLATE DETAILS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const nameplateFields = [
         
          { label: "Make", value: storedFormData?.make },
          { label: "Rated Frequency", value: storedFormData?.ratedFrequency },
          { label: "Serial Number", value: storedFormData?.serialNumber },
          { label: "Insulation Level", value: storedFormData?.insulationLevel },
          { label: "Production Year", value: storedFormData?.productionYear },
          { label: "Closing Coil Supply Volts", value: storedFormData?.closingCoilSupplyVolts },
          { label: "Rated Voltage", value: storedFormData?.ratedVoltage },
          { label: "Opening Coil Supply Volts", value: storedFormData?.openingCoilSupplyVolts },
          { label: "Rated Current", value: storedFormData?.ratedCurrent },
          { label: "Motor Supply Volts", value: storedFormData?.motorSupplyVolts }
        ];

        const nameplateRows = [
         
        ];

        nameplateFields.forEach(field => {
          nameplateRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  field.label, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE },
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   safeToString(field.value), font: "Courier New" })] })],
                  borders: tableBorders,
                   width: { size: 50, type: WidthType.PERCENTAGE }
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: nameplateRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 


        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Insulation Resistance Test - Breaker Position: CLOSE",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const closePositionRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 30, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied DC Voltage (V)", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Resistance", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (testFormData?.closePositionData && testFormData.closePositionData.length > 0) {
          testFormData.closePositionData.forEach(item => {
            closePositionRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.reference), font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.appliedVoltage), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(item.resistanceValue)} ${safeToString(item.resistanceUnit || 'MΩ')}`, font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          closePositionRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 3
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: closePositionRows
          })
        );

        documentSections.push(new Paragraph({ text: "" }));

        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Insulation Resistance Test - Breaker Position: OPEN",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const openPositionRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                
                width: { size: 30, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied DC Voltage (V)", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Resistance", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 35, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (testFormData?.openPositionData && testFormData.openPositionData.length > 0) {
          testFormData.openPositionData.forEach(item => {
            openPositionRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.reference), font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.appliedVoltage), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(item.resistanceValue)} ${safeToString(item.resistanceUnit || 'MΩ')}`, font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          openPositionRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 3
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: openPositionRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Illumination/Heating Circuit Check",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        const illuminationRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (testFormData?.illuminationData && testFormData.illuminationData.length > 0) {
          testFormData.illuminationData.forEach(item => {
            illuminationRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.description), font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.status), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          illuminationRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 2
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: illuminationRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Contact Resistance Test",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        
        const contactResistanceRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Resistance", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            },
                width: { size: 50, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        if (coilIntervalData?.contactResistance && Object.keys(coilIntervalData.contactResistance).length > 0) {
          Object.entries(coilIntervalData.contactResistance).forEach(([phase, value]) => {
            let cleanValue = value;
            if (typeof value === 'string') {
              cleanValue = value.replace(/[¼½¾©®™]/g, '').trim();
            }
            contactResistanceRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${phase}-Phase Resistance`, font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(cleanValue)} μΩ`, font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });
        } else {
          contactResistanceRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "No contact resistance data available", font: "Courier New" })] })],
                  borders: tableBorders,
                  columnSpan: 2
                })
              ]
            })
          );
        }

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: contactResistanceRows
          })
        );

        documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Coil Resistance Check",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);

function formatResistanceValue(resistanceData) {
  if (typeof resistanceData === 'object' && resistanceData !== null) {
    const value = resistanceData.value || resistanceData.resistance || '';
    const unit = resistanceData.unit || 'Ω';
    return `${safeToString(value)} ${unit}`;
  } else {
    
    return `${safeToString(resistanceData)} Ω`;
  }
}


const coilResistanceRows = [
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Coil Type", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
          fill: "a6a6a6" 
        },
        width: { size: 50, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Resistance", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
          fill: "a6a6a6" 
        },
        width: { size: 50, type: WidthType.PERCENTAGE }
      })
    ]
  })
];

if (coilIntervalData?.coilResistance) {
 
  if (coilIntervalData.coilResistance.closing) {
    coilResistanceRows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Closing Coil", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(coilIntervalData.coilResistance.closing), font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    );
  }
  

  if (coilIntervalData.coilResistance.tripping) {
    if (typeof coilIntervalData.coilResistance.tripping === 'object' && !Array.isArray(coilIntervalData.coilResistance.tripping)) {
     
      Object.entries(coilIntervalData.coilResistance.tripping).forEach(([index, trippingData]) => {
        coilResistanceRows.push(
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `Tripping Coil-${parseInt(index) + 1}`, font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
                  fill: "a6a6a6" 
                }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(trippingData), font: "Courier New" })] })],
                borders: tableBorders
              })
            ]
          })
        );
      });
    } else {
      
      coilResistanceRows.push(
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Tripping Coil", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
                fill: "a6a6a6" 
              }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(coilIntervalData.coilResistance.tripping), font: "Courier New" })] })],
              borders: tableBorders
            })
          ]
        })
      );
    }
  }
  
 
  if (coilIntervalData.coilResistance.spring) {
    coilResistanceRows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Spring Charge Motor", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: formatResistanceValue(coilIntervalData.coilResistance.spring), font: "Courier New" })] })],
            borders: tableBorders
          })
        ]
      })
    );
  }
} else {
  coilResistanceRows.push(
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "No coil resistance data available", font: "Courier New" })] })],
          borders: tableBorders,
          columnSpan: 2
        })
      ]
    })
  );
}

documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: coilResistanceRows
  })
);

documentSections.push(new Paragraph({ text: "" })); 



documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Timing Interval Test",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


const timingRows = [
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 31, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R (mSec)", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 23, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y (mSec)", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 23, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B (mSec)", font: "Courier New", bold: true })] })],
        borders: tableBorders,
        shading: {
              fill: "a6a6a6" 
            },
        width: { size: 23, type: WidthType.PERCENTAGE }
      })
    ]
  })
];

if (coilIntervalData && coilIntervalData.timingValues) {
  const timingGroups = {};
  
  Object.keys(coilIntervalData.timingValues).forEach(key => {
    const parts = key.split('-');
    if (parts.length >= 1) {
      const phase = parts[parts.length - 1];
      const reference = parts.slice(0, -1).join('-');
      
      if (!timingGroups[reference]) {
        timingGroups[reference] = {};
      }
      timingGroups[reference][phase] = coilIntervalData.timingValues[key];
    }
  });
  
  const cleanReferenceName = (reference) => {
    if (reference === 'Close') {
      return 'Close';
    } else if (reference.startsWith('Open-')) {
      const number = reference.split('-')[1];
      if (number === '0') {
        return 'Open TC-1';
      } else {
        return `Open TC-${parseInt(number) + 1}`;
      }
    } else if (reference.startsWith('Open TC')) {
      return reference;
    } else if (reference.startsWith('Close-Open-')) {
      const number = reference.split('-')[2];
      if (number === '0') {
        return 'Close-Open TC-1';
      } else {
        return `Close-Open TC-${parseInt(number) + 1}`;
      }
    } else if (reference.startsWith('Close-Open TC')) {
      return reference;
    }
    return reference;
  };
  
  const referenceOrder = ['Close', 'Open-0', 'Open-1', 'Open-2', 'Open-3', 'Open-4',
                         'Open TC-1', 'Open TC-2', 'Open TC-3', 'Open TC-4',
                         'Close-Open-0', 'Close-Open-1', 'Close-Open-2', 'Close-Open-3', 'Close-Open-4',
                         'Close-Open TC-1', 'Close-Open TC-2', 'Close-Open TC-3', 'Close-Open TC-4'];
  
  referenceOrder.forEach(reference => {
    if (timingGroups[reference]) {
      const group = timingGroups[reference];
      const rValue = group['R'] || group['r'] || 'N/A';
      const yValue = group['Y'] || group['y'] || 'N/A';
      const bValue = group['B'] || group['b'] || 'N/A';
      
      const displayName = cleanReferenceName(reference);
      timingRows.push(
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: displayName, font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(yValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(bValue), font: "Courier New" })] })],
              borders: tableBorders
            })
          ]
        })
      );
    }
  });
  
 
  Object.keys(timingGroups).forEach(reference => {
    if (!referenceOrder.includes(reference)) {
      const group = timingGroups[reference];
      const rValue = group['R'] || group['r'] || 'N/A';
      const yValue = group['Y'] || group['y'] || 'N/A';
      const bValue = group['B'] || group['b'] || 'N/A';
      
      const displayName = cleanReferenceName(reference);
      timingRows.push(
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: displayName, font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(yValue), font: "Courier New" })] })],
              borders: tableBorders
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(bValue), font: "Courier New" })] })],
              borders: tableBorders
            })
          ]
        })
      );
    }
  });
} else {
  timingRows.push(
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ children: [new TextRun({ text: "No timing interval test data available", font: "Courier New" })] })],
          borders: tableBorders,
          columnSpan: 4
        })
      ]
    })
  );
}

documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: timingRows
  })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Mechanical Operation",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);

documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operation Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Mechanical Close", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.mechanical?.close === 'yes' ? 'Ok' : (formData?.mechanical?.close === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Mechanical Open", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.mechanical?.open === 'yes' ? 'Ok' : (formData?.mechanical?.open === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Local Operation from TNC Switch",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operation Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Local Close (Test & Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.local?.closeTest === 'yes' ? 'Ok' : (formData?.local?.closeTest === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Local Open (Test & Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.local?.openTest === 'yes' ? 'Ok' : (formData?.local?.openTest === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);

documentSections.push(new Paragraph({ text: "" }));


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Remote Operation",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operation Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remote Close (Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.remote?.closeService === 'yes' ? 'Ok' : (formData?.remote?.closeService === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remote Close (Test & Service)", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.remote?.closeTestService === 'yes' ? 'Ok' : (formData?.remote?.closeTestService === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remote Tripping from Relay", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.remote?.tripping === 'yes' ? 'Ok' : (formData?.remote?.tripping === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);

documentSections.push(new Paragraph({ text: "" })); 


documentSections.push(
  new Paragraph({
    children: [
      new TextRun({
        text: "Indication Checks",
        font: "Courier New",
        bold: true,
        size: 24
      })
    ]
  })
);


documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Indication Type", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 50, type: WidthType.PERCENTAGE }
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CB ON Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.cbOn === 'yes' ? 'Ok' : (formData?.indication?.cbOn === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CB OFF Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.cbOff === 'yes' ? 'Ok' : (formData?.indication?.cbOff === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CB TRIP Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.cbTrip === 'yes' ? 'Ok' : (formData?.indication?.cbTrip === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "BREAKER IN TEST Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.breakerTest === 'yes' ? 'Ok' : (formData?.indication?.breakerTest === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "BREAKER IN SERVICE Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.breakerService === 'yes' ? 'Ok' : (formData?.indication?.breakerService === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "SPRING CHARGED Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.springCharged === 'yes' ? 'Ok' : (formData?.indication?.springCharged === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TRIP CKT HEALTHY -1 Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.tripCkt1 === 'yes' ? 'Ok' : (formData?.indication?.tripCkt1 === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TRIP CKT HEALTHY -2 Indication", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ 
              text: formData?.indication?.tripCkt2 === 'yes' ? 'Ok' : (formData?.indication?.tripCkt2 === 'no' ? 'Not Ok' : 'N/A'),
              font: "Courier New"
            })] })],
            borders: tableBorders
          })
        ]
      })
    ]
  })
);



documentSections.push(new Paragraph({ text: "" })); 

    const convertInchesToTwip = (inches) => {
           return Math.round(inches * 1440);
         };
 
const footerTable = new Table({
  width: { size: 100, type: WidthType.PERCENTAGE, },
  alignment: AlignmentType.LEFT,
  rows: [
    new TableRow({
      height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
      children: [
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "Pie Power",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                }),
                new SimpleField({
                  instruction: "PAGE",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                }),
                new SimpleField({
                  instruction: "NUMPAGES",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        })
      ]
    })
  ]
});
 

 
        const pageBorders = {
  pageBorderTop: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },


  pageBorderRight: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderBottom: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderLeft: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  }
};

      const doc = new Document({
  sections: [
    {
      properties: {
        page: {
          margin: {
            top: convertInchesToTwip(0.5),
            right: convertInchesToTwip(0.5),
            bottom: convertInchesToTwip(1.0),
            left: convertInchesToTwip(0.5)
          },
          borders: pageBorders,
          pageNumbers: {
            start: 1,
            formatType: NumberFormat.DECIMAL
          }
        }
      },
      footers: {
        default: new Footer({
          children: [
            footerTable,
            new Paragraph({
              children: [
                new TextRun({
                  text: "Page ",
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                  children: [PageNumber.CURRENT],
                  font: "Courier New",
                  size: 16
                }),

                new TextRun({
                  text: " of ",
                  font: "Courier New",
                  size: 16
                  }),
               
                new TextRun({
                  children: [PageNumber.TOTAL_PAGES],
                  font: "Courier New",
                  size: 16
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: {
                before: 200
              }
            })
          ]
        })
      },
      headers: lightWatermarkBase64 ? {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: lightWatermarkBase64,
                  transformation: {
                    width: 500,
                    height: 500
                  },
                  floating: {
                    horizontalPosition: {
                      relative: HorizontalPositionRelativeFrom.PAGE,
                      align: HorizontalPositionAlign.CENTER
                    },
                    verticalPosition: {
                      relative: VerticalPositionRelativeFrom.PAGE,
                      align: VerticalPositionAlign.CENTER
                    },
                    wrap: {
                      type: TextWrappingType.BEHIND_TEXT
                    },
                    allowOverlap: true,
                    behindDocument: true
                  }
                })
              ]
            })
          ]
        })
      } : undefined,
      children: documentSections
    }
  ]
});

               Packer.toBlob(doc).then(blob => {
                 resolve(blob);
               }).catch(error => {
                 console.error("Error generating Word blob:", error);
                 reject(error);
               });
               });
       
             }).catch(error => {
               console.error("Error fetching logo:", error);
               reject(error);
             });
       
           } catch (error) {
             console.error("Error generating Word blob:", error);
             reject(error);
           }
         });
       };



  const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  const handleDownloadPdf = async () => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
      const allFormData = loadAllFormDataFromStorage();
      const safeFormData = allFormData && typeof allFormData === 'object' ? allFormData : {
        circuitBreakerData,
        testData,
        contactData,
        operationalChecksData: formData,
        projectDetails
      };
      
      const wordBlob = await generateWordBlob(safeFormData);
      
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${(today.getMonth()+1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
      const filename = `CircuitBreaker_Report_${circuitBreakerData.reportNo || formattedDate}.docx`;
      
      saveAs(wordBlob, filename);
      
     
       
        alert("Word document downloaded successfully");
     
      
    } catch (error) {
      console.error("Error generating Word document:", error);
      setErrorMessage(`Error generating Word document: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };




const handleSave = async (e) => {
  e.preventDefault();
  setFormSubmitted(true);
  setIsLoading(true);
  setErrorMessage("");

  try {
   
    const freshCBData = localStorage.getItem('updatecircuitBreakerFormData');
    const freshTestData = localStorage.getItem('updateTestFormData');
    const freshContactData = localStorage.getItem('updateTimeIntervalData');
    const freshOpData = localStorage.getItem('updateOperationalChecksData');
    
    console.log("Raw localStorage strings:");
    console.log("- CB Data:", freshCBData?.substring(0, 100) + "...");
    console.log("- Test Data:", freshTestData?.substring(0, 100) + "...");
    console.log("- Contact Data:", freshContactData?.substring(0, 100) + "...");
    console.log("- Operational Data:", freshOpData?.substring(0, 100) + "...");
    

    let savedCBData = {};
    let savedTestData = {};
    let savedContactData = {};
    let savedOpChecksData = {};
    
    try {
      savedCBData = freshCBData ? JSON.parse(freshCBData) : {};
      console.log("✓ Parsed CB Data:", savedCBData);
    } catch (e) {
      console.error("❌ Error parsing CB data:", e);
    }
    
    try {
      savedTestData = freshTestData ? JSON.parse(freshTestData) : {};
      console.log("✓ Parsed Test Data:", savedTestData);
    } catch (e) {
      console.error("❌ Error parsing Test data:", e);
    }
    
    try {
      savedContactData = freshContactData ? JSON.parse(freshContactData) : {};
      console.log("✓ Parsed Contact Data:", savedContactData);
    } catch (e) {
      console.error("❌ Error parsing Contact data:", e);
    }
    
    try {
      savedOpChecksData = freshOpData ? JSON.parse(freshOpData) : {};
      console.log("✓ Parsed Operational Data:", savedOpChecksData);
    } catch (e) {
      console.error("❌ Error parsing Operational data:", e);
    }
    
  
    console.log("CB Data keys:", Object.keys(savedCBData));
    console.log("CB Data sample:", {
      make: savedCBData.make,
      ratedFrequency: savedCBData.ratedFrequency,
      serialNumber: savedCBData.serialNumber
    });
    console.log("Test Data keys:", Object.keys(savedTestData));
    console.log("Test Data sample:", {
      closePositionData: savedTestData.closePositionData?.length,
      openPositionData: savedTestData.openPositionData?.length,
      illuminationData: savedTestData.illuminationData?.length
    });
    console.log("Contact Data keys:", Object.keys(savedContactData));
    console.log("Contact Data sample:", {
      numberOfCoils: savedContactData.numberOfCoils,
      contactResistance: savedContactData.contactResistance,
      hasTimingValues: Object.keys(savedContactData.timingValues || {}).length
    });
    console.log("Operational Data keys:", Object.keys(savedOpChecksData));
    console.log("Operational Data sample:", {
      mechanical: savedOpChecksData.mechanical,
      local: savedOpChecksData.local
    });
    
  
    const safeFormData = {
      circuitBreakerData: Object.keys(savedCBData).length > 0 ? savedCBData : {},
      testData: Object.keys(savedTestData).length > 0 ? savedTestData : {},
      contactData: Object.keys(savedContactData).length > 0 ? savedContactData : {},
      operationalChecksData: Object.keys(savedOpChecksData).length > 0 ? savedOpChecksData : {}
    };
    
 
    const convertArrayToDict = (data) => {
      if (!data || typeof data !== 'object') return {};
      if (Array.isArray(data)) return {}; 
      
      const convertedData = {};
     
      for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
          
          convertedData[key] = {};
          value.forEach((item, index) => {
            if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
             
              for (const [subKey, subValue] of Object.entries(item)) {
                if (!convertedData[key][subKey]) {
                  convertedData[key][subKey] = {};
                }
                convertedData[key][subKey][`reading_${index + 1}`] = subValue;
              }
            } else {
              
              convertedData[key][`reading_${index + 1}`] = item;
            }
          });
        } else if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          
          const hasReadingKeys = Object.keys(value).some(k => k.startsWith('reading_'));
          if (hasReadingKeys) {
           
            convertedData[key] = value;
          } else {
           
            convertedData[key] = convertArrayToDict(value);
          }
        } else {
         
          convertedData[key] = value;
        }
      }
     
      return convertedData;
    };
 
    const convertedFormData = {
      circuitBreakerData: convertArrayToDict(safeFormData.circuitBreakerData || {}),
      testData: convertArrayToDict(safeFormData.testData || {}),
      contactData: convertArrayToDict(safeFormData.contactData || {}),
      operationalChecksData: convertArrayToDict(safeFormData.operationalChecksData || {})
    };
 
    
    try {
      const finalCBData = JSON.parse(localStorage.getItem('updatecircuitBreakerFormData') || '{}');
      const finalTestData = JSON.parse(localStorage.getItem('updateTestFormData') || '{}');
      const finalContactData = JSON.parse(localStorage.getItem('updateTimeIntervalData') || '{}');
      const finalOpData = JSON.parse(localStorage.getItem('updateOperationalChecksData') || '{}');
      
    
      if (Object.keys(finalCBData).length > 0) {
        const freshConverted = convertArrayToDict(finalCBData);
        
        convertedFormData.circuitBreakerData = freshConverted;
      }
      
      if (Object.keys(finalTestData).length > 0) {
        const freshConverted = convertArrayToDict(finalTestData);
       
        convertedFormData.testData = freshConverted;
      }
      
      if (Object.keys(finalContactData).length > 0) {
        const freshConverted = convertArrayToDict(finalContactData);
       
        convertedFormData.contactData = freshConverted;
      }
      
      if (Object.keys(finalOpData).length > 0) {
        const freshConverted = convertArrayToDict(finalOpData);
       
        convertedFormData.operationalChecksData = freshConverted;
      }
    } catch (e) {
      console.error("Error in final localStorage read:", e);
    }
   
  
   
    const wordBlob = await generateWordBlob(convertedFormData);
    
    const reader = new FileReader();
    reader.readAsDataURL(wordBlob);
   
    reader.onloadend = async () => {
      try {
        const base64data = reader.result;
        localStorage.setItem('circuitBreakerInspectionWord', base64data);
        
       
        const currentDate = new Date().toISOString().split('T')[0];
        const formLocation = convertedFormData.circuitBreakerData?.location || 
                            savedCBData.location || "";
       
       
        const getProjectId = () => {
          
          
          if (isUpdateMode && reportToUpdate?.project_id) {
            const id = parseInt(reportToUpdate.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from reportToUpdate:", id);
              return id;
            }
          }
          
          if (isUpdateMode && reportToUpdate?.test_data?.circuitBreakerData?.project_id) {
            const id = parseInt(reportToUpdate.test_data.circuitBreakerData.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from reportToUpdate.test_data:", id);
              return id;
            }
          }
         
          if (project?.project_id) {
            const id = parseInt(project.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from project prop:", id);
              return id;
            }
          }
         
          if (projectDetails?.projectId) {
            const id = parseInt(projectDetails.projectId);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from projectDetails:", id);
              return id;
            }
          }
     
          try {
            const createReportData = localStorage.getItem('createReportData');
            if (createReportData) {
              const parsedData = JSON.parse(createReportData);
              if (parsedData.project_id) {
                const id = parseInt(parsedData.project_id);
                if (!isNaN(id) && id > 0) {
                  console.log("✓ Using project_id from createReportData:", id);
                  return id;
                }
              }
            }
          } catch (error) {
            console.error("Error parsing createReportData:", error);
          }
         
          console.error("❌ Could not find valid project_id!");
          throw new Error("Could not determine project ID");
        };
       
        const projectId = getProjectId();
        console.log("=== Final project_id:", projectId, "===");
       
        
        let reportId = null;
        
        if (isUpdateMode && reportToUpdate) {
          reportId = reportToUpdate.id || reportToUpdate.report_id || reportToUpdate._id;
          console.log("✓ Report ID from reportToUpdate:", reportId);
        }
        
        if (!reportId) {
          try {
            const savedReportData = localStorage.getItem('currentReportId');
            if (savedReportData) {
              reportId = JSON.parse(savedReportData);
              console.log("✓ Report ID from localStorage:", reportId);
            }
          } catch (error) {
            console.error("Error getting report ID from localStorage:", error);
          }
        }
        
        if (!reportId) {
          throw new Error("Report ID is required for update operation");
        }
        
        console.log("=== Using Report ID:", reportId, "===");
        
       
        const apiRequestData = {
          report_id: reportId,
          equipment_name: String(
            reportToUpdate?.equipment_name || 
            projectDetails.equipmentName || 
            convertedFormData.circuitBreakerData?.description || 
            savedCBData.description ||
            "Circuit Breaker"
          ),
          test_date: String(
            reportToUpdate?.test_date || 
            convertedFormData.circuitBreakerData?.date || 
            savedCBData.date ||
            currentDate
          ),
          category_name: String(
            reportToUpdate?.category_name || 
            projectDetails.categoryName || 
            "Circuit Breaker"
          ),
          subcategory_name: String(
            reportToUpdate?.subcategory_name || 
            projectDetails.subcategoryName || 
            "Operational Check"
          ),
          sub_project_name: String(
            reportToUpdate?.sub_project_name || 
            projectDetails.subProjectName || 
            convertedFormData.circuitBreakerData?.project || 
            savedCBData.project ||
            "Project"
          ),
          project_id: projectId,
          location: String(
            reportToUpdate?.location || 
            formLocation || 
            projectDetails.location || 
            ""
          ),
          report_file: {  
            report_word: base64data,
            filename: `CircuitBreaker_Test_Report_${Date.now()}.docx`,
            file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          },
          test_data: {
            circuitBreakerData: convertedFormData.circuitBreakerData || {},
            testData: convertedFormData.testData || {},
            contactData: convertedFormData.contactData || {},
            operationalChecksData: convertedFormData.operationalChecksData || {}
          }
        };
   
        
        const verifyCB = JSON.parse(localStorage.getItem('updatecircuitBreakerFormData') || '{}');
        
   
        const apiUrl = `${API_URL}/test_report/update_test_report`;
        
        const response = await fetch(apiUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(apiRequestData),
          mode: 'cors',
          credentials: 'same-origin',
        });
   
        console.log("API Response Status:", response.status);
   
        if (!response.ok) {
          let errorData;
          try {
            errorData = await response.json();
            console.error("Detailed API Error:", errorData);
          } catch (jsonError) {
            const errorText = await response.text();
            console.error("Error response text:", errorText);
            errorData = { message: errorText || response.statusText };
          }
         
          throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
        }
   
        const result = await response.json();
       
        alert("Data updated successfully!");
       
      } catch (error) {
        console.error("❌ Error in processing:", error);
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
   
  } catch (error) {
    console.error("❌ Error in handleSave:", error);
   
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage("Cannot connect to server");
      alert("Cannot connect to server. Please check if the backend is running.");
    } else {
      setErrorMessage(`Error: ${error.message}`);
      alert(`Error saving data: ${error.message}`);
    }
    setIsLoading(false);
  }
};


return (
<div className="form-container450">
<span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '10px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
         {errorMessage && (
        <div className="error-message" style={{ color: 'red', margin: '10px 0', padding: '8px', backgroundColor: '#ffeeee', borderRadius: '4px' }}>
{errorMessage}
</div>
)}

<div className="form-grid">
<div className="form-column">
<h2 className="section-title">OPERATIONAL CHECKS</h2>

<div className="card main-card">
<h3 className="card-header">a) MECHANICAL OPERATION</h3>
<div className="card-body">
  <div className="form-item">
    <label>CLOSE</label>
    <select 
  onChange={(e) => handleChange('mechanical', 'close', e.target.value)}
  value={formData?.mechanical?.close || ''}
  disabled={isLoading}
>
  <option value="">Select</option>
  <option value="yes">Ok</option>
  <option value="no">Not Ok</option>
</select>
  </div>
          
<div className="form-item">
<label>OPEN</label>
<select 
onChange={(e) => handleChange('mechanical', 'open', e.target.value)}
value={formData.mechanical?.open || ''}
disabled={isLoading}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>
</div>
</div>



<div className="card main-card">
<h3 className="card-header">b) LOCAL OPERATION FROM TNC SWITCH</h3>
<div className="card-body">
<div className="form-item">
<label>CLOSE(TEST & SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('local', 'closeTest', e.target.value)}
value={formData.local?.closeTest || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>OPEN(TEST & SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('local', 'openTest', e.target.value)}
value={formData.local?.openTest || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>
</div>
</div>

<div className="card main-card">
<h3 className="card-header">c) REMOTE OPERATION</h3>
<div className="card-body">
<div className="form-item">
<label>CLOSE(SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('remote', 'closeService', e.target.value)}
value={formData.remote?.closeService || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>CLOSE(TEST & SERVICE MODE)</label>
<select 
onChange={(e) => handleChange('remote', 'closeTestService', e.target.value)}
value={formData.remote?.closeTestService || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>TRIPPING FROM RELAY (PROTECTION CKT) / SPARE TRIPPING CONTACTS</label>
<select 
onChange={(e) => handleChange('remote', 'tripping', e.target.value)}
value={formData.remote?.tripping || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>
</div>
</div>
</div>

<div className="form-column">
<h2 className="section-title">INDICATION CHECK</h2>

<div className="card main-card">
<div className="card-body">
<div className="form-item">
<label>CB ON</label>
<select 
onChange={(e) => handleChange('indication', 'cbOn', e.target.value)}
value={formData.indication?.cbOn || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>CB OFF</label>
<select 
onChange={(e) => handleChange('indication', 'cbOff', e.target.value)}
value={formData.indication?.cbOff || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>CB TRIP</label>
<select 
onChange={(e) => handleChange('indication', 'cbTrip', e.target.value)}
value={formData.indication?.cbTrip || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>BREAKER IN TEST</label>
<select 
onChange={(e) => handleChange('indication', 'breakerTest', e.target.value)}
value={formData.indication?.breakerTest || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>BREAKER IN SERVICE</label>
<select 
onChange={(e) => handleChange('indication', 'breakerService', e.target.value)}
value={formData.indication?.breakerService || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>SPRING CHARGED</label>
<select 
onChange={(e) => handleChange('indication', 'springCharged', e.target.value)}
value={formData.indication?.springCharged || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>TRIP CKT HEALTHY -1</label>
<select 
onChange={(e) => handleChange('indication', 'tripCkt1', e.target.value)}
value={formData.indication?.tripCkt1 || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not Ok</option>
</select>
</div>

<div className="form-item">
<label>TRIP CKT HEALTHY -2</label>
<select 
onChange={(e) => handleChange('indication', 'tripCkt2', e.target.value)}
value={formData.indication?.tripCkt2 || ''}
>
<option value="">Select</option>
<option value="yes">Ok</option>
<option value="no">Not OK</option>
</select>
</div>
</div>
</div>
</div>
</div>

<div className="navigation">
<button className="nav-button" onClick={goBack}>Back</button>

<button type="button" className="nav-button" onClick={handleSave} disabled={isLoading}>
{isLoading ? "Processing..." : "Update"}
</button>

{formSubmitted && (
<button 
type="button"
className="nav-button" 
onClick={handleDownloadPdf}
disabled={isLoading}
style={{ 
marginLeft: '10px', 
backgroundColor: '#4CAF50', 
cursor: isLoading ? 'not-allowed' : 'pointer' 
}}
>
Download Word
</button>
)}
</div>
</div>
);
}

export default OperationalChecksForm;




